import { render } from "./sub-menu.vue?vue&type=template&id=9e88407a"
import script from "./sub-menu.vue?vue&type=script&lang=ts"
export * from "./sub-menu.vue?vue&type=script&lang=ts"
script.render = render

export default script